import { EPaymentSummaryStatus } from 'features/PaymentsSummary/components/Status'
import { CreatePartnersPaymentSummaryCategoryInput } from 'gql/generated/graphql'
import { IDocument } from 'utils/file'

export interface IPaymentSummariesFormValues {
  name: string
  files: IPaymentSummaryFile[]
}

export interface IPaymentSummaryFile extends IDocument {
  category: CreatePartnersPaymentSummaryCategoryInput
  errorPath?: string
}

interface IPaymentSummaryFileModel {
  id: string
  category: CreatePartnersPaymentSummaryCategoryInput
  errorPath?: string
  path?: string
}

export const IPaymentSummaryTimelineEventType = {
  PartnersPaymentSummaryEmailRequested: 'PartnersPaymentSummaryEmailRequested',
  PartnersPaymentSummaryCreated: 'PartnersPaymentSummaryCreated'
} as const

export type IPaymentSummaryTimelineEventType =
  (typeof IPaymentSummaryTimelineEventType)[keyof typeof IPaymentSummaryTimelineEventType]

export const IPaymentSummaryTimelineEventName = {
  EmailSent: 'EmailSent',
  PaymentSummaryCreated: 'PaymentSummaryCreated'
} as const

export type IPaymentSummaryTimelineEventName =
  (typeof IPaymentSummaryTimelineEventName)[keyof typeof IPaymentSummaryTimelineEventName]
export interface IPaymentSummaryTimelineEventModel {
  id: string
  correlationID: string
  type: string
  createdAt: Date
  user: {
    id: string
    firstName: string
    lastName: string
    username: string
  }
  action: {
    files: IPaymentSummaryFileModel[]
  }
  name: CreatePartnersPaymentSummaryCategoryInput | IPaymentSummaryTimelineEventName | string
}

export interface IPaymentSummaryEmail {
  id: string
  address: string
  status: string
  reason: string
  updatedAt: Date
  partner: {
    id: string
    name: string
  }
  vehicle: {
    id: string
    name: string
    externalId: string
  }
}
export interface IPaymentSummaryModel {
  id: string
  name: string
  status: EPaymentSummaryStatus
  files: IPaymentSummaryFileModel[]
  createdAt: Date
  timeline?: IPaymentSummaryTimelineEventModel[]
  emails: IPaymentSummaryEmail[]
}
